import {
  getSites,
  getAssets,
  getComponents,
  getAnomalies,
  readOverviewList
} from '@entities'
import { useAsyncResource } from '@hooks'

export function useOverviewResources (companyId) {
  const sites = useAsyncResource(
    async () => readOverviewList(await getSites(companyId), 'sites', companyId),
    [companyId],
    { initialData: null }
  )
  const assets = useAsyncResource(
    async () =>
      readOverviewList(await getAssets(companyId), 'assets', companyId),
    [companyId],
    { initialData: null }
  )
  const components = useAsyncResource(
    async () =>
      readOverviewList(
        await getComponents({ companyId }),
        'components',
        companyId
      ),
    [companyId],
    { initialData: null }
  )
  const anomalies = useAsyncResource(
    async () =>
      readOverviewList(
        await getAnomalies({ companyId }),
        'anomalies',
        companyId
      ),
    [companyId],
    { initialData: null }
  )
  return { sites, assets, components, anomalies }
}
